// @greenlight-spec: 19-design-system.md
// Count formatting shared by the usage surfaces (detail band, list signal,
// map traffic labels) so the same value reads identically everywhere.

const compactFmt = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1,
});
const groupedFmt = new Intl.NumberFormat('en-US');

/** Compact count for dense surfaces: 942 → "942", 12_458 → "12.5K". */
export function formatCountCompact(n: number): string {
  return compactFmt.format(n);
}

/** Full grouped count for stat tiles and tooltips: 12_458 → "12,458". */
export function formatCountFull(n: number): string {
  return groupedFmt.format(n);
}
